<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/vue.png" /></div>
      <p>ZtoMap</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/ztomap/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "2.0.0",
          linkList: [
            ur + "2.0.0/ZMap.js"
          ]
        },
        {
          label: "1.0.0",
          linkList: [
            ur + "1.0.0/ztomap-gl-draw.umd.js",
            ur + "1.0.0/ztomap-gl.js"
          ]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListZtoMap.vue